import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import StyledFileValueContainer from '../StyledFileValueContainer';
import StyledUIFileAttachment from '../StyledUIFileAttachment';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import Small from 'UIComponents/elements/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { REMOVE } from '../types';
import { isReloading } from '../hooks/useFetchBatchResolverWithReload';
import FileSkeleton from '../FileSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const unresolvedFileValueMessage = /*#__PURE__*/_jsx(FormattedMessage, {
  message: 'customerDataProperties.PropertyInputFilesV2.unresolvedFileValue'
});
const isUrl = fileId => /^https?:\/\//i.test(fileId);
const FileValuesUnresolvedList = ({
  isEditDisabled,
  missingFileReferences,
  onFileAction,
  showRemoveAction,
  status
}) => {
  return /*#__PURE__*/_jsx(UIList, {
    children: missingFileReferences.map(fileId => {
      const maybeUrl = isUrl(fileId);
      return /*#__PURE__*/_jsx(UIFlex, {
        direction: "column",
        "data-test-id": "file-unresolved-value-list",
        children: status && isReloading(status) ? /*#__PURE__*/_jsx(FileSkeleton, {}) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs(StyledFileValueContainer, {
            withError: !maybeUrl,
            children: [/*#__PURE__*/_jsx(UITruncateString, {
              children: /*#__PURE__*/_jsx(StyledUIFileAttachment, {
                fileName: maybeUrl ? /*#__PURE__*/_jsx(UILink, {
                  external: true,
                  href: fileId,
                  children: fileId
                }) : fileId,
                size: "small",
                renderPreview: () => /*#__PURE__*/_jsx(UIIcon, {
                  name: "question"
                })
              })
            }), showRemoveAction && /*#__PURE__*/_jsx(UIIconButton, {
              size: "small",
              use: "link",
              onClick: () => onFileAction({
                action: REMOVE,
                fileId
              }),
              disabled: isEditDisabled,
              children: /*#__PURE__*/_jsx(UIIcon, {
                name: "remove",
                size: 12,
                "data-test-id": "file-unresolved-value-remove-icon"
              })
            })]
          }), !maybeUrl && /*#__PURE__*/_jsx(Small, {
            use: "error",
            weight: "medium",
            children: unresolvedFileValueMessage
          })]
        })
      }, fileId);
    })
  });
};
export default FileValuesUnresolvedList;